// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* === COLOR PALETTE (Plain English Names) === */
  
  /* Primary Colors - Main brand colors */
  --sage-green: #7B9F7E;
  --sage-green-light: #A4C3A7;
  --sage-green-dark: #5F7D62;
  --material-green: #4CAF50;
  --material-green-dark: #2E7D32;
  --material-green-darker: #1B5E20;
  
  /* Background Colors */
  --pure-white: #ffffff;
  --off-white: #FAFAF9;
  --cream: #F7F5F1;
  --warm-cream: #FFF9F2;
  --light-gray: #f8f9fa;
  --mint-background: #F0F4F1;
  --mint-background-light: #E8F3E8;
  
  /* Text Colors */
  --charcoal: #1A1A1A;
  --dark-gray: #444444;
  --medium-gray: #555555;
  
  /* Accent Colors */
  --warning-amber: #D97706;
  --warning-yellow: #FFF3CD;
  --warning-yellow-border: #FFB347;
  --trust-blue: #2563EB;
  
  /* Derived Colors - Built from base colors above */
  --primary-sage: var(--sage-green);
  --primary-sage-light: var(--sage-green-light);
  --primary-sage-dark: var(--sage-green-dark);
  --secondary-cream: var(--cream);
  --warm-gray: var(--medium-gray);
  --text-primary: var(--charcoal);
  --text-secondary: var(--dark-gray);
  --accent-gold: var(--warning-amber);
  --accent-blue: var(--trust-blue);
  --white: var(--pure-white);
  --warm-white: var(--off-white);
  
  /* Effects */
  --border-light: rgba(123, 159, 126, 0.12);
  --shadow-soft: 0 2px 8px rgba(123, 159, 126, 0.08);
  --shadow-hover: 0 4px 12px rgba(123, 159, 126, 0.15);
  --shadow-button: 0 4px 14px rgba(123, 159, 126, 0.25);
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, var(--mint-background) 0%, var(--mint-background-light) 100%);
  min-height: 100vh;
  color: var(--text-secondary);
  line-height: 1.6;
  font-weight: 400;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

h1, h2, h3, h4, h5, h6 {
  color: var(--primary-sage-dark);
  line-height: 1.3;
  margin-bottom: 0.5em;
}

h1 {
  font-weight: 300;
  font-size: 2.5rem;
}

h2 {
  font-weight: 500;
  font-size: 1.75rem;
}

h3 {
  font-weight: 500;
  font-size: 1.25rem;
}

.main-heading {
  font-size: 2.5rem;
  font-weight: 300;
  color: var(--primary-sage-dark);
  line-height: 1.2;
}

.section-heading {
  font-size: 1.75rem;
  font-weight: 500;
  color: var(--primary-sage-dark);
}

.body-text {
  font-size: 1rem;
  color: var(--text-secondary);
  line-height: 1.6;
}

p {
  margin-bottom: 1em;
}

a {
  color: var(--primary-sage);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--primary-sage-dark);
  text-decoration: underline;
}

ul, ol {
  margin-bottom: 1em;
}

img {
  max-width: 100%;
  height: auto;
}

/* === NEW COMPONENT STYLES === */

/* Contact Form */
.contact-form {
  max-width: 100%;
}

.contact-form h3 {
  color: var(--text-primary);
  margin-bottom: 12px;
  font-size: 1.3rem;
}

.question-description {
  color: var(--text-secondary);
  margin-bottom: 20px;
  font-style: italic;
}

.contacts-list {
  margin-bottom: 20px;
}

.contact-item {
  background: var(--warm-white);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
}

.contact-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.contact-number {
  font-weight: bold;
  color: var(--primary-sage);
}

.contact-controls {
  display: flex;
  gap: 8px;
}

.move-button, .remove-button {
  background: var(--light-gray);
  border: 1px solid var(--border-light);
  border-radius: 4px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  margin: 0;
  box-shadow: none;
}

.move-button:hover, .remove-button:hover {
  background: var(--primary-sage-light);
  transform: none;
  box-shadow: none;
}

.move-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.remove-button {
  color: #dc3545;
}

.contact-fields {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 12px;
}

.contact-field label {
  display: block;
  font-weight: 500;
  margin-bottom: 4px;
  color: var(--text-primary);
}

.contact-field input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid var(--border-light);
  border-radius: 4px;
  font-size: 14px;
}

.add-contact-button {
  background: var(--primary-sage);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
}

.add-contact-button:hover {
  background: var(--primary-sage-dark);
}

/* Text Input */
.text-input h3 {
  color: var(--text-primary);
  margin-bottom: 12px;
  font-size: 1.3rem;
}

.text-input-field {
  width: 100%;
  padding: 12px;
  border: 1px solid var(--border-light);
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
}

.text-input-field:focus {
  outline: none;
  border-color: var(--primary-sage);
  box-shadow: 0 0 0 2px rgba(123, 159, 126, 0.1);
}

.character-count {
  text-align: right;
  font-size: 12px;
  color: var(--text-secondary);
  margin-top: 4px;
}

/* Multiple Choice */
.multiple-choice h3 {
  color: var(--text-primary);
  margin-bottom: 12px;
  font-size: 1.3rem;
}

.definition-box, .risks-box {
  background: var(--mint-background-light);
  border: 1px solid var(--border-light);
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 16px;
}

.definition-box strong, .risks-box strong {
  color: var(--primary-sage-dark);
}

.options-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.option-item {
  border: 1px solid var(--border-light);
  border-radius: 6px;
  padding: 16px;
  background: var(--warm-white);
}

.option-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
}

.option-label input[type="radio"] {
  margin-top: 2px;
  transform: scale(1.2);
}

.option-text {
  flex: 1 1;
  line-height: 1.4;
}

.conditional-section {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid var(--border-light);
}

.conditional-input {
  background: var(--cream);
  padding: 16px;
  border-radius: 4px;
  border: 1px solid var(--border-light);
}

/* Yes/No Question */
.yes-no-question h3 {
  color: var(--text-primary);
  margin-bottom: 12px;
  font-size: 1.3rem;
}

.yes-no-buttons {
  display: flex;
  gap: 16px;
  margin-top: 20px;
  justify-content: center;
}

.yes-no-buttons .answer-button {
  flex: 1 1;
  max-width: 120px;
}

.answer-button.selected {
  background: var(--primary-sage);
  color: white;
  border-color: var(--primary-sage);
}

/* Navigation */
.navigation-buttons {
  margin-top: 24px;
  text-align: center;
}

.next-button {
  background: var(--primary-sage);
  color: white;
  border: none;
  padding: 12px 32px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}

.next-button:hover {
  background: var(--primary-sage-dark);
}

@media (max-width: 768px) {
  body {
    font-size: 16px;
  }
  
  .contact-fields {
    grid-template-columns: 1fr;
  }
  
  .yes-no-buttons {
    flex-direction: column;
  }
  
  .yes-no-buttons .answer-button {
    max-width: none;
  }
}

@media (min-width: 769px) {
  body {
    font-size: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,gDAAgD;;EAEhD,uCAAuC;EACvC,qBAAqB;EACrB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,8BAA8B;EAC9B,gCAAgC;;EAEhC,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;;EAEhC,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;;EAEtB,kBAAkB;EAClB,wBAAwB;EACxB,yBAAyB;EACzB,gCAAgC;EAChC,qBAAqB;;EAErB,kDAAkD;EAClD,iCAAiC;EACjC,6CAA6C;EAC7C,2CAA2C;EAC3C,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;;EAE9B,YAAY;EACZ,yCAAyC;EACzC,kDAAkD;EAClD,oDAAoD;EACpD,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,iGAAiG;EACjG,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,iCAAiC;;AAEjC,iBAAiB;AACjB;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,4BAA4B;EAC5B,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[":root {\n  /* === COLOR PALETTE (Plain English Names) === */\n  \n  /* Primary Colors - Main brand colors */\n  --sage-green: #7B9F7E;\n  --sage-green-light: #A4C3A7;\n  --sage-green-dark: #5F7D62;\n  --material-green: #4CAF50;\n  --material-green-dark: #2E7D32;\n  --material-green-darker: #1B5E20;\n  \n  /* Background Colors */\n  --pure-white: #ffffff;\n  --off-white: #FAFAF9;\n  --cream: #F7F5F1;\n  --warm-cream: #FFF9F2;\n  --light-gray: #f8f9fa;\n  --mint-background: #F0F4F1;\n  --mint-background-light: #E8F3E8;\n  \n  /* Text Colors */\n  --charcoal: #1A1A1A;\n  --dark-gray: #444444;\n  --medium-gray: #555555;\n  \n  /* Accent Colors */\n  --warning-amber: #D97706;\n  --warning-yellow: #FFF3CD;\n  --warning-yellow-border: #FFB347;\n  --trust-blue: #2563EB;\n  \n  /* Derived Colors - Built from base colors above */\n  --primary-sage: var(--sage-green);\n  --primary-sage-light: var(--sage-green-light);\n  --primary-sage-dark: var(--sage-green-dark);\n  --secondary-cream: var(--cream);\n  --warm-gray: var(--medium-gray);\n  --text-primary: var(--charcoal);\n  --text-secondary: var(--dark-gray);\n  --accent-gold: var(--warning-amber);\n  --accent-blue: var(--trust-blue);\n  --white: var(--pure-white);\n  --warm-white: var(--off-white);\n  \n  /* Effects */\n  --border-light: rgba(123, 159, 126, 0.12);\n  --shadow-soft: 0 2px 8px rgba(123, 159, 126, 0.08);\n  --shadow-hover: 0 4px 12px rgba(123, 159, 126, 0.15);\n  --shadow-button: 0 4px 14px rgba(123, 159, 126, 0.25);\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: linear-gradient(135deg, var(--mint-background) 0%, var(--mint-background-light) 100%);\n  min-height: 100vh;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  font-weight: 400;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  color: var(--primary-sage-dark);\n  line-height: 1.3;\n  margin-bottom: 0.5em;\n}\n\nh1 {\n  font-weight: 300;\n  font-size: 2.5rem;\n}\n\nh2 {\n  font-weight: 500;\n  font-size: 1.75rem;\n}\n\nh3 {\n  font-weight: 500;\n  font-size: 1.25rem;\n}\n\n.main-heading {\n  font-size: 2.5rem;\n  font-weight: 300;\n  color: var(--primary-sage-dark);\n  line-height: 1.2;\n}\n\n.section-heading {\n  font-size: 1.75rem;\n  font-weight: 500;\n  color: var(--primary-sage-dark);\n}\n\n.body-text {\n  font-size: 1rem;\n  color: var(--text-secondary);\n  line-height: 1.6;\n}\n\np {\n  margin-bottom: 1em;\n}\n\na {\n  color: var(--primary-sage);\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\na:hover {\n  color: var(--primary-sage-dark);\n  text-decoration: underline;\n}\n\nul, ol {\n  margin-bottom: 1em;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\n/* === NEW COMPONENT STYLES === */\n\n/* Contact Form */\n.contact-form {\n  max-width: 100%;\n}\n\n.contact-form h3 {\n  color: var(--text-primary);\n  margin-bottom: 12px;\n  font-size: 1.3rem;\n}\n\n.question-description {\n  color: var(--text-secondary);\n  margin-bottom: 20px;\n  font-style: italic;\n}\n\n.contacts-list {\n  margin-bottom: 20px;\n}\n\n.contact-item {\n  background: var(--warm-white);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.contact-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.contact-number {\n  font-weight: bold;\n  color: var(--primary-sage);\n}\n\n.contact-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.move-button, .remove-button {\n  background: var(--light-gray);\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0;\n  margin: 0;\n  box-shadow: none;\n}\n\n.move-button:hover, .remove-button:hover {\n  background: var(--primary-sage-light);\n  transform: none;\n  box-shadow: none;\n}\n\n.move-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.remove-button {\n  color: #dc3545;\n}\n\n.contact-fields {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 12px;\n}\n\n.contact-field label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 4px;\n  color: var(--text-primary);\n}\n\n.contact-field input {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid var(--border-light);\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.add-contact-button {\n  background: var(--primary-sage);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.add-contact-button:hover {\n  background: var(--primary-sage-dark);\n}\n\n/* Text Input */\n.text-input h3 {\n  color: var(--text-primary);\n  margin-bottom: 12px;\n  font-size: 1.3rem;\n}\n\n.text-input-field {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid var(--border-light);\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.text-input-field:focus {\n  outline: none;\n  border-color: var(--primary-sage);\n  box-shadow: 0 0 0 2px rgba(123, 159, 126, 0.1);\n}\n\n.character-count {\n  text-align: right;\n  font-size: 12px;\n  color: var(--text-secondary);\n  margin-top: 4px;\n}\n\n/* Multiple Choice */\n.multiple-choice h3 {\n  color: var(--text-primary);\n  margin-bottom: 12px;\n  font-size: 1.3rem;\n}\n\n.definition-box, .risks-box {\n  background: var(--mint-background-light);\n  border: 1px solid var(--border-light);\n  border-radius: 6px;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n\n.definition-box strong, .risks-box strong {\n  color: var(--primary-sage-dark);\n}\n\n.options-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.option-item {\n  border: 1px solid var(--border-light);\n  border-radius: 6px;\n  padding: 16px;\n  background: var(--warm-white);\n}\n\n.option-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  cursor: pointer;\n}\n\n.option-label input[type=\"radio\"] {\n  margin-top: 2px;\n  transform: scale(1.2);\n}\n\n.option-text {\n  flex: 1;\n  line-height: 1.4;\n}\n\n.conditional-section {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border-light);\n}\n\n.conditional-input {\n  background: var(--cream);\n  padding: 16px;\n  border-radius: 4px;\n  border: 1px solid var(--border-light);\n}\n\n/* Yes/No Question */\n.yes-no-question h3 {\n  color: var(--text-primary);\n  margin-bottom: 12px;\n  font-size: 1.3rem;\n}\n\n.yes-no-buttons {\n  display: flex;\n  gap: 16px;\n  margin-top: 20px;\n  justify-content: center;\n}\n\n.yes-no-buttons .answer-button {\n  flex: 1;\n  max-width: 120px;\n}\n\n.answer-button.selected {\n  background: var(--primary-sage);\n  color: white;\n  border-color: var(--primary-sage);\n}\n\n/* Navigation */\n.navigation-buttons {\n  margin-top: 24px;\n  text-align: center;\n}\n\n.next-button {\n  background: var(--primary-sage);\n  color: white;\n  border: none;\n  padding: 12px 32px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.next-button:hover {\n  background: var(--primary-sage-dark);\n}\n\n@media (max-width: 768px) {\n  body {\n    font-size: 16px;\n  }\n  \n  .contact-fields {\n    grid-template-columns: 1fr;\n  }\n  \n  .yes-no-buttons {\n    flex-direction: column;\n  }\n  \n  .yes-no-buttons .answer-button {\n    max-width: none;\n  }\n}\n\n@media (min-width: 769px) {\n  body {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
